/**
 * Feature 12 — "Finish setup" banner shown on every authenticated page
 * while `User.setup_completed_at` is null.
 *
 * Mounted from DashboardLayout — hides on /onboarding/* so we don't
 * tell the user to "Continue setup" while they're already in setup.
 */
import { Link, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';


export default function SetupWizardBanner() {
  const { user } = useAuthStore();
  const location = useLocation();
  if (!user) return null;
  if (user.setup_completed_at) return null;
  if (user.role === 'admin') return null;
  if (location.pathname.startsWith('/onboarding')) return null;

  return (
    <div className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3">
      <span className="text-sm text-amber-900">
        You haven't finished setup yet.
      </span>
      <Link
        to={`/onboarding/${user.role}`}
        className="rounded-lg bg-amber-500 px-3 py-1.5 text-xs font-semibold text-white hover:bg-amber-600"
      >
        Continue setup
      </Link>
    </div>
  );
}
